import $ from 'jquery';
import 'formstone/src/js/core';
import 'formstone/src/js/mediaquery';
import 'formstone/src/js/cookie';
import 'formstone/src/js/transition';
import { settings } from '@/helpers/config';

const DEFAULT_SETTINGS = {};

class Formstone {
	constructor(config) {
		this.config = config;
	}

	get shouldInit() {
		return window.Formstone;
	}

	setup() {
		if (typeof $.mediaquery !== 'undefined') {
			$.mediaquery({
				minWidth: Object.values(settings.breakpoints)
			});
		}

		if (typeof $.cookie !== 'undefined') {
			$.cookie({ path: '/' });
		}
	}

	init() {
		if (!this.shouldInit) return;

		this.setup();
	}
}

export default function factory(settings = {}) {
	let config = Object.assign({}, DEFAULT_SETTINGS, settings);

	let module = new Formstone(config);

	module.init();

	return module;
}
